module.exports = __webpack_public_path__ + "img/04.古楸树（杨树田-摄）.bc96e7dd.jpg";